import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { BudgetPageActionCreators, AppActionCreators } from '../../../actions';
import { BudgetPageCard } from './BudgetPageCard';
import { RouteUrls } from '../../../configs/routeUrls';
import { BudgetPageType } from '../../../utils/enums';

class BudgetPageContainer extends Component {
	componentDidMount() {
		const { budgetYearValue } = this.props.match.params;
		const { type, prevPathname } = this.props;
		this.props.getBudgetPage(budgetYearValue, type);

		const pageProps = this.getPageName(type, budgetYearValue);
		if (prevPathname !== RouteUrls.Budget.list.actual) {
			this.props.setBreadcrumbs([
				{
					url: RouteUrls.Budget.list.actual,
					displayName: 'Budżet obywatelski'
				},
				{
					url: prevPathname,
					displayName: 'Głosowanie'
				},
				{
					url: pageProps.url,
					displayName: pageProps.name
				}
			]);
		} else {
			this.props.setBreadcrumbs([
				{
					url: RouteUrls.Budget.list.actual,
					displayName: 'Budżet obywatelski'
				},
				{
					url: pageProps.url,
					displayName: pageProps.name
				}
			]);
		}
	}
	getPageName(type, budgetYearValue) {
		switch (type) {
			case BudgetPageType.Help: {
				return { name: 'Pomoc', url: RouteUrls.Budget.pages.helpFunc(budgetYearValue) };
			}
			case BudgetPageType.Schedule: {
				return { name: 'Harmonogram', url: RouteUrls.Budget.pages.scheduleFunc(budgetYearValue) };
			}
			default: {
				return { name: 'Do pobrania', url: RouteUrls.Budget.pages.prerequisiteFunc(budgetYearValue) };
			}
		}
	}
	render() {
		const { budgetPage, isBudgetPageLoading, onCancel } = this.props;
		return <BudgetPageCard {...budgetPage} isBudgetPageLoading={isBudgetPageLoading} onCancel={onCancel} />;
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isBudgetPageLoading: state.budgetPage.isBudgetPageLoading,
		budgetPage: state.budgetPage.budgetPage,
		prevPathname: state.routing.location.prevPathname
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...BudgetPageActionCreators, ...AppActionCreators }, dispatch),
		goTo: (url) => dispatch(push(url)),
		onCancel: () => dispatch(goBack())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BudgetPageContainer);
